/**
 *
 * Asynchronously loads the component for Mse001
 * Author: TruongTx
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
